import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e78ae18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "center-menu" }
const _hoisted_2 = ["name", "onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center-menu-item-bg" }, null, -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "center-menu-item-title" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center-menu-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "center-menu-item-bg" }),
  /*#__PURE__*/_createElementVNode("span", { class: "center-menu-item-title" }, " 退出登錄 ")
], -1))

import { reactive,getCurrentInstance } from "vue";
  import {onBeforeRouteUpdate} from "vue-router";
  import Login from "@/js/utils/login"

  
export default {
  __name: 'index',
  setup(__props) {

  const { proxy } = getCurrentInstance()
  const Util = proxy.$Util
  const CONFIG = proxy.$CONFIG
  const Router = proxy.$Router
  const data = reactive({
    navBarData:[
      {
        name:'個人中心',
        isNav:false,
        route:'/center/info'
      },
      {
        name:'我的收藏',
        isNav:false,
        route:'/center/collect'
      },
      {
        name:'我的評論',
        isNav:false,
        route:'/center/message'
      },
      {
        name:'我的積分',
        isNav:false,
        route:'/center/point'
      },
      {
        name:'我的點讚',
        isNav:false,
        route:'/center/good'
      },
      {
        name:'我的反饋',
        isNav:false,
        route:'/center/feedback'
      },
      {
        name:'更改密碼',
        isNav:false,
        route:'/center/resetPassword'
      },
      {
        name:'關聯第三方賬號',
        isNav:false,
        route:'/center/relate'
      },
      {
        name:'註銷賬號',
        isNav:false,
        route:'/center/delete'
      }
    ]
  })
  const changeNav = (path='')=>{
    if(path===''){
      path = Router.info().currentRoute.value.path
    }
    for (let i = 0;i<data.navBarData.length;i++){
      data.navBarData[i].isNav = false
    }
    let navBarData = Util.deepCopy({obj:data.navBarData})
    let navIndex = navBarData.reverse().findIndex(item=>path.indexOf(item.route) !== -1)
    if(navIndex!==-1){
      data.navBarData[data.navBarData.length - navIndex - 1].isNav = true
    }
  }
  changeNav()
  onBeforeRouteUpdate(async (to, from) => {
    changeNav(to.path)
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    let isTrue = toDepth < fromDepth
    if(window.innerWidth<=767){
      let toIndex = data.navBarData.findIndex(item=>item.route===to.path)
      let fromIndex = data.navBarData.findIndex(item=>item.route===from.path)
      if(toIndex!==-1&&fromIndex!==-1){
        isTrue=toIndex<fromIndex
      }
    }
    to.meta.transition = isTrue ? 'route-slide-out-left' : 'route-slide-in-left'
  })
  const navClick=(route)=>{
    if(window.innerWidth<767){
      $(".scroll-page")[0].scrollTo({top:0})
    }
    Router.push({path:route})
  }
  const loginOut=()=>{
    Login.loginout()
  }

return (_ctx, _cache) => {
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.navBarData, (v, i) => {
      return (_openBlock(), _createElementBlock("div", {
        name: v.name,
        class: _normalizeClass('center-menu-item ' + (v.isNav===true?'center-menu-item-active':'')),
        key: i,
        onClick: $event => (navClick(v.route))
      }, [
        _hoisted_3,
        _createElementVNode("img", {
          class: "center-menu-item-img",
          src: `${_unref(CONFIG).BASE_STATIC_URL}user/center/select.png`
        }, null, 8, _hoisted_4),
        _createElementVNode("span", _hoisted_5, _toDisplayString(v.name), 1),
        _createElementVNode("img", {
          class: "center-menu-item-right",
          src: `${_unref(CONFIG).BASE_STATIC_URL}user/center/right.png`
        }, null, 8, _hoisted_6)
      ], 10, _hoisted_2))
    }), 128)),
    _createVNode(_component_el_popconfirm, {
      title: "確認退出登錄？",
      onConfirm: _cache[0] || (_cache[0] = $event => (loginOut()))
    }, {
      reference: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    })
  ]))
}
}

}